import { render, staticRenderFns } from "./RightTransacao.vue?vue&type=template&id=598ab28f&scoped=true"
import script from "./RightTransacao.vue?vue&type=script&lang=js"
export * from "./RightTransacao.vue?vue&type=script&lang=js"
import style0 from "./RightTransacao.vue?vue&type=style&index=0&id=598ab28f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ab28f",
  null
  
)

export default component.exports